import React, { ReactElement, useCallback, useRef } from 'react';
import './Select.scss';

export interface SelectProps {
  onChange: (value: string) => void;
  children: ReactElement;
  value: string;
  displayValue?: string;
  label?: string;
  isBlack?: boolean;
}

const Select = (props: SelectProps) => {
  const { onChange, children, value, label, isBlack, displayValue } = props;
  let boxClass = 'SelectBox';
  if (label) {
    boxClass += value
      ? ' SelectBox--has-label SelectBox--has-value'
      : ' SelectBox--has-label';
  }
  if (isBlack) boxClass += ' Select__black_border';

  const selRef = useRef<HTMLSelectElement>();

  const handleIconClick = useCallback(() => {
    selRef.current.focus();
    selRef.current.click();
  }, []);

  return (
    <div className={boxClass}>
      <select
        ref={selRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {children}
      </select>
      {/*<span>{displayValue ?? value}</span>*/}
      {label && <label>{label}</label>}
      <span
        onClick={handleIconClick}
        className={`icon icon-arrow-up SelectBox__icon_arrow
           ${
             value
               ? 'SelectBox__icon_arrow_topValue'
               : 'SelectBox__icon_arrow_topNoValue'
           }`}
      />
    </div>
  );
};

export default Select;
